export const RESOLUTION_STATUS_LIST_KEY = 'RESOLUTION_STATUS_LIST';
export const RESOLUTION_STATUS_ONE_KEY = 'RESOLUTION_STATUS_ONE_KEY';

export const RESOLUTION_STATUS_ALL_KEY = 'RESOLUTION_STATUS_ALL_KEY';

export const RESOLUTION_STATUS_ALLOWED_LIST_KEY = 'RESOLUTION_STATUS_ALLOWED_LIST_KEY';
